import React, { Fragment } from 'react'
//import config from '../../../store/config/config.json'
import {Grid, Icon, Typography, CardContent, Card, CardHeader } from '@material-ui/core';

export default function PurchaseDetail(props) {

    const purchaseDetail = props.purchaseDetail
    const searchInfo = props.bookingItems 
    const prices = props.prices
    let  tarifa_comisionable = 0  
    let  comision_trenes_minorista = 0
    let  precio_neto_minorista = 0 
    let  fee_adicional_minorista = 0 
    let  fee_trenes = 0 
    let  precio_neto_sin_gastos_minorista = 0
    let  gastos_administrativos_minorista = 0 
    let  precio_neto_agencia_minorista = 0                         
    let  totalPrice = 0
    let  nodePrice = props.config.pricing.search
    let  totalPriceAgency = 0
       

    totalPrice = prices.api.values[nodePrice]
    totalPriceAgency = prices.api.values[nodePrice]
    tarifa_comisionable = prices.api.values.tarifa_comisionable
    comision_trenes_minorista = prices.api.values.comision_trenes_minorista
    precio_neto_minorista = prices.api.values.precio_neto_minorista
    fee_adicional_minorista = prices.api.values.fee_adicional_minorista
    fee_trenes = prices.api.values.fee_trenes?prices.api.values.fee_trenes:prices.api.values.fee_trenes_minorista
    precio_neto_sin_gastos_minorista = prices.api.values.precio_neto_sin_gastos_minorista
    gastos_administrativos_minorista = prices.api.values.gastos_administrativos_minorista
    precio_neto_agencia_minorista = prices.api.values.precio_neto_agencia_minorista

  
    const { /* purchaseDetail, */ messages} = props
    
    return (
        <Card className="card-detail card">
            <CardHeader className="head-resume"
                avatar={<Icon className="head-resume-icon">{purchaseDetail.icon}</Icon>}
                title={purchaseDetail.title}
            />
            <CardContent>
                <div className="resume-detail">
                    {searchInfo && searchInfo.map((leg, i) => 
                        (<Grid className="row" container  key={i}  spacing={1}>
                            <Grid item xs={8}>
                                { leg.leg && leg.leg.origin ?
                                    <Typography className="small">{leg.leg.origin.localLabel} - {leg.leg.destination.localLabel}</Typography>
                                :
                                    <Typography className="small">{props.bookingItems[0].label}</Typography>
                                }
                            </Grid>
                            <Grid item xs={4} className="text-right">
                                <Typography className="small">{purchaseDetail.currency} {leg.prices.api.values[nodePrice].toFixed(2)}</Typography>
                            </Grid>
                        </Grid>)
                    )} 

                    <hr/>
                    
                    <Grid className="total-resume" container spacing={1}>
                        <Grid item xs={7}>
                            <Typography>{props.totalText}</Typography></Grid>
                        <Grid item xs={5}>
                            <Typography className="text-right">{purchaseDetail.currency} {tarifa_comisionable.toFixed(2) }</Typography></Grid>
                        
                    </Grid>

                    <hr/>

                    <Grid className="row" container spacing={1}>
                        <Grid item xs={8}> 
                            <Fragment>
                                {/* <Typography className="small" >Tarifa Comisionable</Typography> */}
                                {(comision_trenes_minorista > 0) && 
                                    
                                    <Typography className="small">
                                        {props.config.client.name === "turivel" ? "Descuento" : "Comisión"}
                                    </Typography>
                                }
                                {(precio_neto_minorista > 0) &&
                                    <Typography className="small" >Subtotal</Typography>
                                }
                                {(fee_adicional_minorista > 0) &&
                                    <Typography className="small" >Booking Fee</Typography>
                                }
                                {(fee_trenes > 0) &&
                                    <Typography className="small" >Booking Fee</Typography>
                                }
                                {(precio_neto_sin_gastos_minorista > 0) &&
                                    <Typography className="small" >Tarifa Neta</Typography>
                                }
                                {(gastos_administrativos_minorista > 0) &&
                                    <Typography className="small" >Gastos Administrativos</Typography>
                                }
                            </Fragment>
                        
                        </Grid>
                        <Grid item xs={4} className="text-right" >
                        {/* <Typography className="text-right" className="small">{purchaseDetail.currency} {tarifa_comisionable.toFixed(2) }</Typography>   */}
                        {(comision_trenes_minorista > 0) &&   
                            <Typography className="text-right small">{purchaseDetail.currency} {comision_trenes_minorista.toFixed(2)}</Typography>
                        }
                        {(precio_neto_minorista > 0) &&
                            <Typography className="text-right small">{purchaseDetail.currency} {precio_neto_minorista.toFixed(2) } </Typography> 
                        }
                        {(fee_adicional_minorista > 0) &&
                            <Typography className="text-right small">{purchaseDetail.currency} {fee_adicional_minorista.toFixed(2)}</Typography> 
                        }
                        {(fee_trenes > 0) &&
                            <Typography className="text-right small">{purchaseDetail.currency} {fee_trenes.toFixed(2) }</Typography> 
                        }
                        {(precio_neto_sin_gastos_minorista > 0) &&
                            <Typography className="text-right small">{purchaseDetail.currency} {precio_neto_sin_gastos_minorista.toFixed(2) }</Typography>
                        }
                        {(gastos_administrativos_minorista > 0) &&
                            <Typography className="text-right small">{purchaseDetail.currency} {gastos_administrativos_minorista.toFixed(2) }</Typography>
                        }                        
                        </Grid> 
                    </Grid>
                    <Grid className="total-resume" container spacing={1}>
                        <Grid item xs={7}>
                            <Typography>Total Neto Agencia</Typography></Grid>
                        <Grid item xs={5}>
                            <Typography className="text-right">{purchaseDetail.currency} {precio_neto_agencia_minorista.toFixed(2) }</Typography></Grid>
                        
                    </Grid>
                    {messages && <div className="info-box info-cargos">
                        {messages.map((item, i) => <Typography className="small" key={i} >{item.value} </Typography>)}
                    </div>}                    

                </div>
            </CardContent>
        </Card>
    )
}
